/**
 * drl-card JS
 */

import $ from 'jquery';

Drupal.behaviors.drl_card_popup = {
  attach(context) {
    // Add Class On Click
    $('.drl-card-item .bottom-section .icon-box', context).on('click', function addClass() {
      $(this)
        .find('.icon')
        .toggleClass('open');
    });

    // Our Company Card characterLimit
    $('.drl-company-card .card-body .discription-block p', context).text(function characterLimit(
      index,
      currentText
    ) {
      const maxLength = $(this)
        .parent()
        .attr('data-maxlength');
      if (currentText.length >= maxLength) {
        return `${currentText.substr(0, maxLength)}...`;
      }
      return currentText;
    });
  },
};
